const sessionStorageHelper = {
    getItem(key) {
        try {
            const value = window.sessionStorage.getItem(key);
            const ngValue = window.sessionStorage.getItem(`ng-${key}`);
            const returnValue = value || ngValue;
            return JSON.parse(returnValue);
        } catch (err) {
            console.log(err);
            return null;
        }
    },
    setItem(key, value) {
        try {
            window.sessionStorage.setItem(key, JSON.stringify(value));
        } catch (err) {
            console.log(err);
        }
    },
    removeItem(key) {
        try {
            window.sessionStorage.removeItem(key);
        } catch (err) {
            console.log(err);
        }
    }
};

export default sessionStorageHelper;
